import './App.css';
import { BrowserRouter, Routes, Route, HashRouter } from 'react-router-dom';

// import LoginDetails from './pages/LoginDetails';
import LoginDetails from './pages/LoginDetails';
import CandidateDetails from './pages/CandidateDetails';
import DashboardPage from './pages/DashboardPage';
import TechSelect from './pages/TechSelect';
import ForgotPassword from './pages/ForgotPasswordPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import GenerateLink from './pages/GenerateLinkPage';
import Protected from './pages/protected';

import UsersQuestions from './Users/UsersQuestions';
import UsersSummary from './Users/UsersSummary';
import TermsAndConditionPage from './Users/TermsAndConditionPage';
import UsersInterview from './Users/UserInterview';
import InstructionsPage from './Users/Instructionspage';
import UsersDemoQuestions from './Users/UsersDemoQuestions';



import ZPOCSpeech from './pages/ZPOCSpeech';
import AudioRecorder from './pages/AudioRecorder';

import ContactPage from './pages/ContactPage';
import AboutUsPage from './pages/AboutUsPage';
import JobPost from './pages/JobPost';
import CandidateLists from './pages/CandidateLists';
import JobDetailsPage from './pages/JobDetailsPage';
import InterviewsTabPage from './pages/InterviewsTabPage'
import ClientsPage from './pages/ClientsPage';
import AddJobPostPage from './pages/AddJobPostPage';
import OrganizationPage from './pages/OrganizationPage';

import CodeInterviewPage from './pages/CodeInterviewPage';
import HomePage from './pages/HomePage';
import MultiFactorAuthentication from './pages/MultiFactorAuthentication'
import CandidateListsForManager from './pages/CandidateListsForManager';
import UserRegistration from './pages/UserRegistrationPage';
import OTPVerificationPage from './pages/OTPVerificationPage';

import AdminLoginPage from './adminPages/AdminLoginPage';
import OrgListPage from './adminPages/OrgListPage';
import RegisteredCandidates from './adminPages/RegisteredCandidates';
import CandidateDetailsPage from './adminPages/CandidateDetailsPage';

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/forgot-pwd" element={<ForgotPassword />} />
        <Route path="/change-pwd" element={<ChangePasswordPage />} />
        <Route path="/candidate" element={<CandidateDetails />} />
        
        <Route path="/login" element={<Protected Component={LoginDetails} />} />
        <Route path="/link-generator" element={<GenerateLink />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/techselect" element={<TechSelect />} />

        <Route path="/users-questions" element={<UsersQuestions />} />
        <Route path="/users-questions-old" element={<UsersInterview />} />
        <Route path="/users-summary" element={<UsersSummary />} />
        <Route path="/users-test" element={<TermsAndConditionPage />} />
        <Route path="/users-instructions" element={<InstructionsPage />} />
        <Route path="/UsersDemoQuestions" element={<UsersDemoQuestions/>} />



        <Route path="/speech" element={<ZPOCSpeech />} />
        <Route path="/audio-speech" element={<AudioRecorder />} />
        <Route path="/home-page" element={<HomePage />} />
        <Route path="/" element={<Protected Component={LoginDetails} />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path ='/job-post' element={<Protected Component={JobPost} />}></Route>
        <Route path ='/candidate-info' element={<CandidateLists/>}></Route>
        <Route path ='/jobdetails' element={<JobDetailsPage/>}></Route>
        <Route path ='/interviews-tab' element={<InterviewsTabPage/>}></Route>
        <Route path ='/clients-page' element={<ClientsPage/>}></Route>
        <Route path ='/add-job-post' element={<AddJobPostPage/>}></Route>
        <Route path ='/admin/org' element={<OrganizationPage/>}></Route>

        <Route path ='/code-interview' element={<CodeInterviewPage/>}></Route>
        <Route path ='/MFA' element={<MultiFactorAuthentication/>}></Route>
        <Route path ='/candidate-info-manager' element={<CandidateListsForManager/>}></Route>
        <Route path ='/user-registration' element={<UserRegistration/>}></Route>
        <Route path ='/otp-verify' element={<OTPVerificationPage/>}></Route>

        <Route path ='/admin-login' element={<AdminLoginPage/>}></Route>
        <Route path ='/organisation' element={<OrgListPage/>}></Route>
        <Route path ='/registered-candidates' element={<RegisteredCandidates/>}></Route>
        <Route path ='/candidates-details' element={<CandidateDetailsPage/>}></Route>

      </Routes>
    </HashRouter>
  );
}

export default App;
